import React, { FC, useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Accordion from 'react-bootstrap/cjs/Accordion';
import RootStoreContext from '../../../../model/RootStoreContext';
import { ICategory } from '../../../../model/category/Category';
import { PubRouteItems } from '../../../routes';
import { sortByString } from '@yakoffice/yakoffice-firebase';
import { useLocation } from 'react-router';
import styles from './categoriesNavigation.module.sass';
import { CategoryNavigationAccordion } from './categoryNavigationAccordion';
import { AddCategoryButton } from '../AddCategoryButton';
import Button from 'react-bootstrap/Button';
import { ButtonGroup, OverlayTrigger } from 'react-bootstrap';
import ToolTip from 'react-bootstrap/Tooltip';

export const CategoriesNavigation: FC = observer(() => {
    const rootStore = useContext(RootStoreContext);
    const location = useLocation();
    const [expanded] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [filterArchived, setFilterArchived] = useState(true);
    const isActive = location.pathname.includes(PubRouteItems.Categories);

    const toggleCategoriesNavigation = () => {
        setCollapsed(!collapsed);
    };

    return (
        <div className={`${styles.categoriesNavigationWrapper} ${collapsed && styles.collapsed}`}>
            <div className={`d-flex justify-content-between ${styles.categoriesNavToolbar}`}>
                <AddCategoryButton />
                <ButtonGroup>
                    <OverlayTrigger placement="top" overlay={
                        <ToolTip id="button-tooltip">Filter archived</ToolTip>}>
                        <Button variant={filterArchived ? 'outline-primary' : 'primary'}
                                onClick={() => setFilterArchived(!filterArchived)}><i className="fas fa-filter" />
                        </Button>
                    </OverlayTrigger>
                    <Button variant="outline-dark"
                            className={`${styles.collapseToggle} ${collapsed && styles.collapsed}`}
                            onClick={toggleCategoriesNavigation}>
                        <i className="fas fa-chevron-left" />
                    </Button>
                </ButtonGroup>
            </div>
            <Accordion className={`nav-item ${isActive ? 'active' : ''}`} activeKey={expanded ? 'folderIconCat' : ''}
                       defaultActiveKey={'folderIconCat'}>
                <Accordion.Collapse eventKey="folderIconCat" id="accordion-categories"
                                    className={styles.accordionCategories}>
                    <div className={styles.categoryList}>
                        <ul className={styles.categoryListTop}>
                            {rootStore.categoryStore.categories
                                .filter(category => !filterArchived || category.status !== 'archived')
                                .filter(category => category.parent == null).slice().sort(sortByString('name'))
                                .map((category: ICategory) => {
                                    return <CategoryNavigationAccordion key={`category-${category.id}`}
                                                                        currentCategory={rootStore.categoryStore.currentCategory}
                                                                        category={category}
                                                                        allCategories={rootStore.categoryStore.categories}
                                                                        expandAll={true}
                                                                        isParentCategory={true}
                                                                        filterArchived={filterArchived} />;
                                })}
                        </ul>
                    </div>
                </Accordion.Collapse>
            </Accordion>
        </div>
    );
});
